import { instance as apiInstance } from "~/services/api";
import { logout } from "~/store/slices/auth";

const refreshTokenMiddleware = (store) => {
  const { dispatch } = store;

  apiInstance.interceptors.response.use(
    (response) => {
      // console.log({ response });
      if (response.data?.token) {
        sessionStorage.setItem("loginToken", response.data?.token);
      }
      return response;
    },
    async (err) => {
      console.log({ err });
      const originalConfig = err.config;

      if (originalConfig.url !== "auth/login" && err.response) {
        //Access token was expired

        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = false;
          console.log("STORE", store);

          dispatch(logout(err.response.status));
        } else {
          // orignalConfig._retry = true;
          // try {
          //   let form = new FormData();
          //   form.append("refresh_token", tokenService.getLocalRefreshToken());
          //   const response = await apiInstance.post("/user/refresh_token", form);
          //   const accessToken = response.data?.data;
          //   tokenService.updateLocalAccessToken(accessToken);
          //   dispatch(refreshToken(accessToken));
          //   return apiInstance(orignalConfig);
          // } catch (error) {
          //   return Promise.reject(error);
          // }
        }
      }
      return Promise.reject(err);
    }
  );
};

export default refreshTokenMiddleware;
